import { ConclusionKeys, FindingAreasEnum, getFindingAreaDisplayText, zodQuestionTypes } from "../surveyStatusSchemas";

const questionnaireOpwPart2 = {
    id: FindingAreasEnum.OffPayrollWorkersSelfEmployedWorkers,
    name: getFindingAreaDisplayText(FindingAreasEnum.OffPayrollWorkersSelfEmployedWorkers),
    questions: [
        {
            id: `${FindingAreasEnum.OffPayrollWorkersSelfEmployedWorkers}:Q4`,
            text: "Do you engage workers in a direct/self-employed capacity?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.OffPayrollWorkersSelfEmployedWorkers}:Q6A`,
                no: ConclusionKeys.Green,
            },
        },
        {
            id: `${FindingAreasEnum.OffPayrollWorkersSelfEmployedWorkers}:Q5A`,
            text: "What is your approximate spend on direct/self-employed workers per annum?",
            type: zodQuestionTypes.enum.DropDown,
            values: [
                "Less than £100k",
                "£100k - £500k",
                "Above £500k",
            ],
            flow: {
                next: ConclusionKeys.Green,
            },
        },
        {
            id: `${FindingAreasEnum.OffPayrollWorkersSelfEmployedWorkers}:Q5B`,
            text: "What is your approximate spend on direct/self-employed workers per annum?",
            type: zodQuestionTypes.enum.DropDown,
            values: [
                "Less than £100k",
                "£100k - £500k",
                "Above £500k",
            ],
            flow: {
                next: ConclusionKeys.Red,
            },
        },
        {
            id: `${FindingAreasEnum.OffPayrollWorkersSelfEmployedWorkers}:Q6A`,
            text: "Do you formally assess these workers from an employment status perspective?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.OffPayrollWorkersSelfEmployedWorkers}:Q5A`,
                no: `${FindingAreasEnum.OffPayrollWorkersSelfEmployedWorkers}:Q5B`
            },
        },
    ],
};

export default questionnaireOpwPart2;
